import { useLocation, useNavigate } from "react-router-dom";

export const useTogglePopup = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const openPopup = (popup: string) => {
    const params = new URLSearchParams(location.search);
    params.delete("popup");
    setTimeout(() => {
      params.append("popup", popup);
      navigate(
        {
          search: `?${params.toString()}`,
        },
        { replace: true },
      );
    }, 100);
  };

  const closePopup = () => {
    const params = new URLSearchParams(location.search);
    params.delete("popup");
    navigate(
      {
        search: `?${params.toString()}`,
      },
      { replace: true },
    );
  };

  return { openPopup, closePopup };
};
